import React, { useRef } from 'react';
import './App.css';
import Header from './components/Header';
import Meme from './components/Meme';
import Footer from './components/Footer';

function App() {
  return (
    <>
      <Header />
      <Meme />
      <div className='footer'>
        <Footer />
      </div>
    </>
  );
}

export default App;

